<template>
  <div class="register">
    <div class="header">
      <div class="item title">青年创业服务</div>
      <div class="item">
        <div class="text">已有账号?</div>
        <div class="a" @click="login('/login')">立即登录</div>
      </div>
    </div>
    <div class="from">
      <div class="frombox">
        <div class="title">
          <div
            class="item sbs"
            @click="chang(0)"
            :class="0 == curr ? 'act' : ''"
          >
            总园企业注册
          </div>
          <div
            class="item sbs"
            :class="1 == curr ? 'act' : ''"
            @click="chang(1)"
          >
            分园企业注册
          </div>
        </div>
        <!--  -->
        <div class="zy" v-if="0 == curr">
          <input
            type="text"
            value=""
            class="line"
            placeholder="用户账号（6~20位字母数字）"
            v-model="username"
          />
          <input type="text" v-model="realname" value="" class="line" placeholder="真实姓名" />
          <input type="text" v-model="password" value="" class="line" placeholder="密码" />
          <input type="text" v-model="phone" value="" class="line" placeholder="手机号码" />
<!--          <div class="line code">
            <input type="text" value="" class=" " placeholder="验证码" />
            <div class="codetext">获取验证码</div>
          </div>
          <div class="second">
            <div class="text">是否选择创业导师</div>
            <div class="icon"></div>
            <div class="text">是</div>
            <div class="icon"></div>
            <div class="text">否</div>
          </div>-->
          <div class="btn" @click="register">立即注册</div>
        </div>
        <div class="fy" v-if="1 == curr">
          <div class="first sbs">
           <!-- <cuihai-combox
              label="选择分园"
              placeholder="海东分园"
              :candidates="candidates"
              isDisabled
            ></cuihai-combox> -->

          </div>
          <input
              type="text"
              value=""
              class="line"
              placeholder="用户账号（6~20位字母数字）"
              v-model="username"
          />
          <input type="text" v-model="realname" value="" class="line" placeholder="真实姓名" />
          <input type="text" v-model="password" value="" class="line" placeholder="密码" />
          <input type="text" v-model="phone" value="" class="line" placeholder="手机号码" />
<!--          <div class="line code">
            <input type="text" value="" class=" " placeholder="验证码" />
            <div class="codetext sbs">获取验证码</div>
          </div>-->

          <div class="btn sbs" @click="register">立即注册</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {httpGet,httpPost} from "../../utils/request.js"
export default {
  components: {
    // cuihaiCombox
  },
  data() {
    return {
      curr: 0,
      candidates: ["海东分园", "aa分园", "bb分园"],
      username:'',
      realname:'',
      password:'',
      phone:''
    };
  },
  methods: {
    login(e) {
      // uni.navigateBack({});
      this.$router.push({ path: e, query: {} });
    },
    register(e) {
      let param = {
        username:this.username,
        password:this.password,
        realname:this.realname,
        phone:this.phone,
        userType:this.curr
      }
      if(this.username.length < 6 || this.username.length > 20){
        this.$message({
          message: '请输入6~20位字母或数字账号!',
          type: 'warning'
        });
         return
      }
      if(!/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/.test(this.password)){
        this.$message({
          message: '密码由8位数字、大小写字母和特殊符号组成!',
          type: 'warning'
        });
        return
      }
      if(this.realname == ""){
        this.$message({
          message: '请输入真实姓名!',
          type: 'warning'
        });
        return
      }
      if(!/^1[3456789]\d{9}$/.test(this.phone)){
        this.$message({
          message: '请输入正确的手机号!',
          type: 'warning'
        });
        return
      }
      let that = this;
      httpPost('/web/user/addWebUser',param).then(res=>{
        if(res.success){
          that.$message({
            message: "注册成功",
            type: 'success'
          });
          that.$router.push("/login")
        }else {
          that.$message.error(res.message);
        }
      }).catch(error=>{
        console.log('error')
      })
    },
    chang(e) {
      this.curr = e;
    }
  }
};
</script>

<style scoped lang="scss">
.register,
page {
  background: #f4f5f9;
  overflow: hidden;
}
.header {
  width: 100vw;
  line-height: 70px;
  // display: flex;
  // justify-content: space-evenly;
  overflow: hidden;
  background-color: #ffffff;
  line-height: 70px;
  .item {
	  float: right;
	  margin-right: 0.8rem;
    font-size: 17px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    .text {
      float: left;
    }
    .a {
      color: #00bdff;
      float: left;
    }
    .a:hover {
      cursor: pointer;
    }
  }
  .title {
	  float: left;
	  margin-left: 0.68rem;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
  }
}
.from {
  width: 750px;
  // height: 854rem;
  overflow: hidden;
  margin: 1.4rem auto;
  background-color: #ffffff;
  .frombox {
    width: 420px;
    margin: 1.1rem auto;
    .title {
      overflow: hidden;
      width: 100%;
      .item {
        float: left;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        margin-right: 25px;
        line-height: 40px;
      }
      .act {
        color: #00bdff;
        border-bottom: 0.04rem solid #00bdff;
      }
    }
    .first {
      margin: 0.3rem 0 0;
    }
    .line {
      width: 90%;
      height: 40px;
      padding: 0 5%;
      margin: 0;
      border: 0.01rem solid #dddddd;
      border-radius: 0.02rem;
      font-size: 16px;
      margin-top: 0.2rem;
    }
    .code {
      overflow: hidden;
      // display: flex;
      border: none;
      padding: 0;
      width: 100%;
	  height: 40px;
	  position: relative;
      input {
        width: 63%;
        height: 38px;
        border: 0.01rem solid #dddddd;
        padding: 0;
        padding-left: 5%;
		// float: left;
		position: absolute;
		left: 0;
		top: 0;
      }
      .codetext {
		  // float: right;
		  position: absolute;
		  right: 0;
		  top: 0;
        width:32%  ;
        font-size: 16px;
        text-align: center;
        line-height: 40px;
        height: 38px;
        background: #f4f5f9;
        border: 1px solid #dddddd;
        border-radius: 0 2px 2px 0;
        border-left: none;
      }
    }
    .btn {
      width: 100%;
      font-size: 17px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      height: 0.6rem;
      background: #00bdff;
      border-radius: 0.12rem;
      margin-top: 0.57rem;
      text-align: center;
      line-height: 0.6rem;
    }
    .second {
      margin-left: 0.3rem;

      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #bbbbbb;
      line-height: 40px;
      margin-top: 0.3rem;
      overflow: hidden;
      div {
        float: left;
      }
      .text {
        margin-right: 0.2rem;
      }
      .icon {
        margin-right: 0.2rem;
        width: 16px;
        height: 16px;
        border: 1px solid #bbbbbb;
        margin-top: 11px;
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .header {
    .title {
      font-size: 0.28rem;
    }
    .item {
      font-size: 0.32rem;
    }
  }
  // .from {
  //   width: 690rem;
  //   // height: auto;
  //   overflow: hidden;
  //   .frombox {
  //     width: 630rem;
  //     .title {
  //       overflow: hidden;
  //       width: 100%;
  //       .item {
  //         font-size: 16px;
  //       }
  //     }
  //     .line {
  //       font-size: 14px;
  //     }
  //     .btn {
  //       font-size: 15px;
  //     }
  //   }
  // }
}
</style>
